import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import { BottomNextButton } from "components/common/BottomNextButton";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { onboardingApi } from "../../../../api/onboardingApi";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../../recoil/userAtom";
import {
  getMultiPlanPrices,
  getSinglePlanPrice,
  isSinglePlanPricingModel,
} from "../../../../components/task/payment/planTypes";

const formatPrice = (n: number) => n.toLocaleString("ko-KR");

export default function Habit_6() {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);

  const pricingModel = user?.pricingModel ?? "aeg";
  const isSinglePlan = isSinglePlanPricingModel(pricingModel);
  const standardPrice = isSinglePlan
    ? (getSinglePlanPrice(pricingModel) ?? 395000)
    : (getMultiPlanPrices(pricingModel)?.challenger ?? 395000);

  const standardPriceText = formatPrice(standardPrice);

  const handleNext = () => {
    navigate(`/onboarding_new/habit/7`);
  };

  const pageKey = "habit_6";

  const { mutate: savePage } = useMutation(
    (pageId: string) => onboardingApi.savePage(pageId),
    {
      onSuccess: () => {},
    }
  );

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    savePage(pageKey);
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        spacing={2}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={700}
          sx={{
            color: theme.vars.palette.Content.Highlight,
          }}
        >
          {"매일 쌓여가는 변화."}
        </CustomTypography>

        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {
            "디스턴싱은 매일 꾸준히 참여하며 차곡차곡 변화를 쌓아가는 프로그램입니다."
          }
        </CustomTypography>

        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {`프로그램은 100일간 진행되며, 비용은 챌린저 플랜 기준 ${standardPriceText}원입니다.`}
        </CustomTypography>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
